export var formatSalary = function (minSal, maxSal, showSuffix) {
    if (showSuffix === void 0) { showSuffix = true; }
    var minSalary = parseInt((minSal === null || minSal === void 0 ? void 0 : minSal.toString()) || '0');
    var maxSalary = parseInt((maxSal === null || maxSal === void 0 ? void 0 : maxSal.toString()) || '0');
    var suffix = showSuffix ? 'PA' : '';
    var minSalToDisplay;
    var maxSalToDisplay;
    var salaryToDisplay;
    if (isNaN(minSalary) && isNaN(maxSalary)) {
        return '';
    }
    else {
        if (minSal && maxSal) {
            minSalToDisplay = new Intl.NumberFormat('en-in').format(minSal);
            maxSalToDisplay = new Intl.NumberFormat('en-in').format(maxSal);
            var finalSalary = minSalToDisplay.toString().concat(' - ', maxSalToDisplay.toString());
            salaryToDisplay = finalSalary.concat(' ', suffix);
            return salaryToDisplay;
        }
        else if (minSal && !maxSal) {
            minSalToDisplay = new Intl.NumberFormat('en-in').format(minSal);
            salaryToDisplay = minSalToDisplay.concat(' ', suffix);
            return salaryToDisplay;
        }
        else if (maxSal && !minSal) {
            maxSalToDisplay = new Intl.NumberFormat('en-in').format(maxSal);
            salaryToDisplay = maxSalToDisplay.concat(' ', suffix);
            return salaryToDisplay;
        }
        else {
            return '';
        }
    }
};
export var generateNoticePeriodString = function (noticePeriod) {
    if (noticePeriod === void 0) { noticePeriod = []; }
    var noticePeriodString = '';
    noticePeriod.map(function (item, index) {
        if (item === '3_months') {
            noticePeriodString = noticePeriodString + '3 Months +';
        }
        if (item === '2_months') {
            noticePeriodString = noticePeriodString + '2 Months +';
        }
        if (item === '1_month') {
            noticePeriodString = noticePeriodString + '1 Month +';
        }
        if (item === '15_days') {
            noticePeriodString = noticePeriodString + '0-15 Days';
        }
        if (item === 'immediate') {
            noticePeriodString = noticePeriodString + 'Currently serving notice period';
        }
        if (item === 'months') {
            noticePeriodString = noticePeriodString + 'More than 3 Months';
        }
        if (item === 'any') {
            noticePeriodString = noticePeriodString + 'Any';
        }
        if (index + 1 !== noticePeriod.length) {
            noticePeriodString = noticePeriodString + ' / ';
        }
    });
    return noticePeriodString;
};
export var getLocationString = function (arr) {
    if (arr === void 0) { arr = []; }
    if (!Array.isArray(arr))
        return '';
    var temp = [];
    arr.map(function (item) {
        var _a = item.city, city = _a === void 0 ? '' : _a, _b = item.state, state = _b === void 0 ? '' : _b;
        var city_state = [city, state].join('');
        if (city_state)
            temp.push(city_state);
    });
    return temp.join(', ');
};
export var generateLocationPreferenceString = function (data) {
    var arr = [];
    if (data === null || data === void 0 ? void 0 : data.isRemote)
        arr.push('Remote');
    if (data === null || data === void 0 ? void 0 : data.isHybrid)
        arr.push('Hybrid');
    if (data === null || data === void 0 ? void 0 : data.isOnPremises)
        arr.push('On Premises');
    return arr.join(', ');
};
export var locationData = function (item) {
    if (getLocationString(item === null || item === void 0 ? void 0 : item.location).length && generateLocationPreferenceString(item).length) {
        return "".concat([getLocationString(item === null || item === void 0 ? void 0 : item.location).trim()].join(', '), " ( ").concat(generateLocationPreferenceString(item), " )");
    }
    else {
        return [getLocationString(item === null || item === void 0 ? void 0 : item.location), generateLocationPreferenceString(item)].join(' ');
    }
};
export var jdScoreMatchColor = function (value) {
    if (value <= 20) {
        return '#FF0000';
    }
    if (value >= 21 && value <= 40) {
        return '#FF672C';
    }
    if (value >= 40 && value <= 100) {
        return '#324ECF';
    }
};
export var getJobQuery = function (_a) {
    var jobTitle = _a.jobTitle, organizationName = _a.organizationName, minExp = _a.minExp, maxExp = _a.maxExp, minSal = _a.minSal, maxSal = _a.maxSal;
    var title = '';
    title += jobTitle;
    if (organizationName)
        title += " at ".concat(organizationName);
    if (minExp >= 0 && maxExp >= 0)
        title += " Exp: ".concat(minExp, " to ").concat(maxExp, " Years-");
    if (minSal !== undefined && maxSal !== undefined && minSal >= 0 && maxSal >= 0)
        title += " Salary: ".concat(minSal, " to ").concat(maxSal, " Years");
    title = title.replace(/[^a-zA-Z0-9 ]/g, '');
    title = title.replace(/ +/g, '-');
    return title;
};
